import { Button, Typography, withStyles } from '@material-ui/core';
import React from 'react';
import { withRouter } from 'react-router';
import { compose } from 'recompose';
import BackButton from '../atoms/BackButton';

const styles = {
  contentContainer: {
    padding: 40,
    backgroundColor: '#fff',
    borderRadius: 4
  },
  title: {
    fontSize: 20,
    fontWeight: 'bold',
    marginBottom: 5
  },
  body: {
    padding: '0 40px'
  },
  buttonBox: {
    marginTop: 45
  },
  userBox: {
    margin: '45px 0 8px',
    fontSize: 20,
    fontWeight: 700,
    lineHeight: '28px'
  },
  statusTable: {
    border: '1px solid #E0E0E0',
    display: 'flex',
    fontSize: 14,
    fontWeight: 400,
    marginTop: 8
  },
  statusTitle: {
    backgroundColor: '#F7F7F7',
    fontWeight: 700,
    padding: '16px 12px',
    width: 228
  },
  statusText: {
    padding: '16px 12px'
  }
};

const enhance = compose();

const Main = enhance(
  ({ classes, receipt, statusReceiptSelected, handleCancel, handleSubmit }) => {
    const getTextStatus = () => {
      let text = '';

      if (statusReceiptSelected === 1) {
        text = '承認済み';
      } else if (statusReceiptSelected === 2) {
        text = '承認保留';
      } else if (statusReceiptSelected === 3) {
        text = '承認待ち';
      } else if (statusReceiptSelected === 4) {
        text = '非承認';
      }

      return text;
    };

    return (
      <div className={classes.contentContainer}>
        <div className={classes.body}>
          <Typography className={classes.title} variant="h6">
            承認&レシート詳細
          </Typography>
          <div className={classes.userBox}>
            <div>{receipt.userId}</div>
            <div>{`${receipt.userName} 様`}</div>
          </div>
          <div className={classes.statusTable}>
            <div className={classes.statusTitle}>申請結果</div>
            <div className={classes.statusText}>{getTextStatus()}</div>
          </div>
          <div className={classes.buttonBox}>
            <BackButton
              onClickAction={() => {
                handleCancel();
              }}
            />

            <Button
              color="primary"
              variant="contained"
              onClick={() => {
                handleSubmit();
              }}
            >
              更新
            </Button>
          </div>
        </div>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
